<p-dialog
    header="{{ 'projects.pages.details.members' | translate }}"
    [(visible)]="visible"
    styleClass="pending-attendees-dialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    style="height: 10%; background-color: red"
    (onHide)="closeAttendeesModal(participantsSlidePanel)"
>
    <wudo-slide-panel #participantsSlidePanel style="width: auto">
        <ul centerPanel class="list-group list-participants attendees-list-panel">
            <li
                *ngFor="let profile of project.attendees; let i = index"
                class="list-group-item p-d-inline-flex"
                [ngClass]="{ clickable: isMemberOrOwnerOfProject }"
                (click)="isMemberOrOwnerOfProject && (selectedAttendee = profile); isMemberOrOwnerOfProject && participantsSlidePanel.slideToRight()"
            >
                <a
                    *ngIf="profile.active"
                    class="p-my-auto p-d-inline-flex nostyle"
                    [routerLink]="['/directory/profile', profile.id]"
                    pTooltip="Voir le profil"
                    tooltipPosition="top"
                >
                    <app-user-avatar
                        [ngClass]="{ surrounded: i == 0 }"
                        class="p-d-none p-d-md-block"
                        [firstName]="profile.firstName"
                        [lastName]="profile.lastName"
                        [picture]="profile.profilePicture"
                    ></app-user-avatar>
                    <div class="p-ml-2 p-mt-auto p-d-flex p-flex-column">
                        <div class="p-my-auto p-mt-auto">{{ profile.firstName }} {{ profile.lastName }}</div>
                        <div class="p-my-auto p-mb-auto organization-position">
                            {{ profile.jobTitle }}{{ (profile.jobTitle ? 'projects.pages.details.at' : '') | translate
                            }}{{ profile.organizationName }}
                        </div>
                    </div>
                </a>
                <div *ngIf="isMemberOrOwnerOfProject" class="p-d-inline-flex p-ml-auto p-my-auto">
                    <button
                        icon="pi icon-user-tie"
                        pButton
                        pRipple
                        *ngIf="!profile.isOwner"
                        pTooltip="Designer porteur"
                        tooltipPosition="top"
                        [style]="{ heigth: '15px' }"
                        class="p-button-primary p-button-rounded p-button-text p-my-auto p-button-sm"
                        (click)="toggleUpdateOwnerModal($event, profile)"
                    ></button>
                    <button
                        pButton
                        pRipple
                        *ngIf="!profile.isOwner"
                        pTooltip="Retirer du projet"
                        tooltipPosition="top"
                        icon="pi icon-user-minus"
                        class="p-button-danger p-button-rounded p-button-text p-my-auto p-button-sm"
                        (click)="toggleRemoveUserModal($event, profile)"
                    ></button>
                    <button
                        pButton
                        pRipple
                        pTooltip="{{ 'projects.pages.details.message.seeMessage' | translate }}"
                        tooltipPosition="top"
                        icon="pi icon-arrow-left1"
                        class="p-button-secondary p-button-rounded p-button-text p-my-auto p-button-sm"
                        (click)="selectedAttendee = profile; participantsSlidePanel.slideToRight()"
                    ></button>
                </div>
            </li>
        </ul>
        <div rightPanel class="p-d-flex p-flex-column p-px-2">
            <div class="border border-bottom-0 p-p-2 rounded-top p-d-inline-flex">
                <p-avatar
                    [image]="selectedAttendee.profilePicture"
                    styleClass="avatar p-m-2"
                    size="large"
                    shape="circle"
                    [style]="{ 'background-color': 'var(--gray-light)' }"
                    [label]="!selectedAttendee.profilePicture ? getLabel(selectedAttendee.firstName, selectedAttendee.lastName) : ''"
                ></p-avatar>
                <div class="p-ml-2 p-d-flex p-flex-column">
                    <div class="p-mt-auto">
                        {{ selectedAttendee.firstName }}
                        {{ selectedAttendee.lastName }}
                    </div>
                    <div class="p-mb-auto organization-position">
                        {{ selectedAttendee.jobTitle }}{{ (selectedAttendee.jobTitle ? 'projects.pages.details.at' : '') | translate
                        }}{{ selectedAttendee.organizationName }}
                    </div>
                </div>
            </div>
            <div class="border rounded-bottom p-p-2">
                <div class="fw-b primary-1">
                    {{ 'projects.pages.details.message.motivationToParticipate' | translate }}
                </div>
                <p-scrollPanel [style]="{ width: '100%', height: '50vh' }">
                    <div class="attendeeMotivation" [innerHTML]="selectedAttendee.motivation"></div>
                </p-scrollPanel>
            </div>
        </div>
    </wudo-slide-panel>
    <p-footer>
        <button
            *ngIf="participantsSlidePanel.activePanelPosition != 'CENTER'"
            type="button"
            class="btn btn-light"
            (click)="participantsSlidePanel.slideToCenter()"
        >
            {{ 'components.button.back' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="closeAttendeesModal(participantsSlidePanel)" data-dismiss="modal">
            {{ 'components.button.buttonClose' | translate }}
        </button>
    </p-footer>
</p-dialog>
<dialog-set-project-owner
    [userToUpdate]="userToUpdate"
    [project]="project"
    [visible]="updateOwnerModalVisible"
    (visibleChange)="toggleUpdateOwnerModal($event, null)"
></dialog-set-project-owner>

<dialog-remove-attendee
    [userToUpdate]="userToUpdate"
    [project]="project"
    [visible]="removeUserModalVisible"
    (visibleChange)="toggleRemoveUserModal($event, null)"
></dialog-remove-attendee>
